<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align: center;">P.D.</p>
<p style="text-align: center;">You make me feel legitimately understood and give me the confidence to be unapologetically and authentically myself.</p>
<p style="text-align: center;">It is truly the best gift one human being can give to another.</p>
<p style="text-align: center;">You are forever my non-biological sister (whether you like it or not).</p><br/>
<p style="text-align: center;">K.T.</p>
<p style="text-align: center;">My surrogate mother.</p>
<p style="text-align: center;">You have been my friend, my conscience, and my safe haven since the day we first said ‘hello’.</p>
<p style="text-align: center;">It is a gift I will never take for granted.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?09b25dc0